import { defineStore } from 'pinia';
import { ref } from "vue";
import axios from 'axios';

import { endpoint } from "../issues_utils.js";


export const useIssueStore = defineStore(
  'issues',
  () => {
    const park_list = ref([]);
    const staffers = ref([]);
    const agency_list = ref([]);
    const ticket_list = ref([]);
    const loading_data = ref(false);
    const displayed_tickets = ref([]);
    const parks_with_issues = ref([]);
    const agencies_with_issues = ref([]);
    const creators_with_issues = ref([]);

    async function load_staffers() {
      loading_data.value = true;
      try {
        const response = await axios.get(
          endpoint('internal/current/users/?is_staff=1&is_active=1'),
          { withCredentials: true });
        if (response.statusText === "OK") {
          staffers.value = response.data;
        }
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_parks() {
      loading_data.value = true;
      try {
        const response = await axios.get(
          endpoint('internal/current/parks/'),
          { withCredentials: true });
        if (response.statusText === "OK") {
          park_list.value = response.data;
        }
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_agencies() {
      loading_data.value = true;
      try {
        const response = await axios.get(
          endpoint('internal/current/agency/'),
          { withCredentials: true });
        if (response.statusText === "OK") {
          agency_list.value = response.data;
        }
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_tickets() {
      loading_data.value = true;
      try {
        let next = true;
        const out = [];
        let url = endpoint('internal/current/tickets/');
        while (next) {
          const response = await axios.get(url, { withCredentials: true });
          if (response.statusText === "OK") {
            out.push(...response.data.results);
            url = response.data.next;
            if (url === null || url === undefined) {
              next = false;
            }
          } else {
            next = false;
            console.log(response);
          }
        }
        ticket_list.value = out;
        const park_ids = new Set();
        ticket_list.value.forEach(ticket => park_ids.add(ticket['park']));
        const requests = Array.from(park_ids).map(id => axios.get(endpoint(`internal/current/parks/${id}/`), { withCredentials: true }));
        const responses = await Promise.all(requests);
        for (const res of responses) {
          if (res.statusText !== "OK") {
            throw new Error(`Error loading park data: ${res.statusText}`);
          }
        }
        parks_with_issues.value = responses.map(res => res.data);
        parks_with_issues.value.forEach(park => {
          if (park.agency === null) {
            park.agency = -1;
          }
        });
        const agencies_ids = parks_with_issues.value.map(park => park['agency']);
        agencies_with_issues.value = agency_list.value.filter(agency => agencies_ids.includes(agency.id));
        agencies_with_issues.value.push({ id: -1, name: 'Not assigned' });
        agencies_with_issues.value.forEach(agency => agency['parks'] = []);
        parks_with_issues.value.forEach(park => {
          for (const agency of agencies_with_issues.value) {
            if (park['agency'] === agency.id) {
              agency['parks'].push(park['id']);
              break;
            }
          }
        });
        ticket_list.value.forEach(ticket => {
          ticket['agency'] = agencies_with_issues.value.find(a => a['parks'].includes(ticket['park']));
          ticket['is_open'] = false;
        });

        displayed_tickets.value = ticket_list.value.sort((ticket1, ticket2) => {
          if (ticket1['priority'] < ticket2['priority']) {
            return -1;
          }
          if (ticket1['priority'] > ticket2['priority']) {
            return 1;
          }
          if (ticket1.id > ticket2.id) {
            return -1;
          }
          if (ticket1.id < ticket2.id) {
            return 1;
          }
        });
        creators_with_issues.value = staffers.value.filter(s => ticket_list.value.map(t => t['made_by']).includes(s.id));
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_data() {
      await load_parks();
      await load_staffers();
      await load_agencies();
      await load_tickets();
    }

    return {
      park_list, staffers, agency_list, ticket_list, loading_data,
      displayed_tickets, parks_with_issues, agencies_with_issues, creators_with_issues,
      load_tickets, load_parks, load_data
    };
  }
);
